import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { ManageStateLicense as ManageStateLicenseReducer } from '../../reducers/r_index';
import { GetLicenses as GetLicensesReducer } from '../../reducers/r_index';
import { FilterLicenses as FilterLicensesReducer } from '../../reducers/r_index';

//Components
import GestioneStatoLicenzaCmp from '../../components/gestione_licenze/GestioneStatoLicenzaCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});

class GestioneStatoLicenza extends Component {

    render() {
        const { ...props } = this.props;

        return (
            <GestioneStatoLicenzaCmp {...props} />
        );

    }
}

GestioneStatoLicenza.propTypes = {
    blockLicense: PropTypes.func.isRequired,

    unblockLicense: PropTypes.func.isRequired,

    manageStateLicenseRequestStatus: PropTypes.string.isRequired,
    manageStateLicenseErrorMessage: PropTypes.string,

    showGestioneStatoDialog: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,

    selected_license: PropTypes.shape({}).isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};


const mapDispatchToProps = dispatch => ({
    blockLicense: (pk, codiceUtente) => { dispatch(ManageStateLicenseReducer.creators.blockLicenseRequest(pk, codiceUtente)) },
    unblockLicense: (pk, codiceUtente) => { dispatch(ManageStateLicenseReducer.creators.unblockLicenseRequest(pk, codiceUtente)) },

    showGestioneStatoDialog: () => { dispatch(ManageStateLicenseReducer.creators.showGestioneStatoDialog()); },

    refreshLicenses: (codiceUtente) => { dispatch(GetLicensesReducer.creators.getLicensesRequest(codiceUtente)); },
    resetFilters: () => { dispatch(FilterLicensesReducer.creators.resetFilters()) },
});

const mapStateToProps = state => ({
    manageStateLicenseRequestStatus: state['manage-state-license'].status,
    manageStateLicenseErrorMessage: state['manage-state-license'].error,
    isOpen: state['manage-state-license'].isOpen,

    selectedRowIndex: state['filtro-licenze'].selectedRowIndex,

    selected_license: state['filtro-licenze'].selected_license,

    codiceUtente: state['logged-user'].codiceUtente,  

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GestioneStatoLicenza));